(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const euro = (cents) => {
    const v = cents / 100;
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: v % 1 ? 2 : 0 }).format(v);
  };

  const header = $('[data-header]');
  if (header) {
    const f = () => header.classList.toggle('scrolled', window.scrollY > 10);
    f();
    window.addEventListener('scroll', f, { passive: true });
  }

  const body = document.body;
  const openMenu = (o) => {
    body.classList.toggle('menu-open', o);
    $$('[data-burger]').forEach((b) => b.setAttribute('aria-expanded', String(o)));
  };
  $$('[data-burger]').forEach((b) => b.addEventListener('click', () => openMenu(true)));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => openMenu(false)));

  const els = $$('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach((el) => io.observe(el));
  } else els.forEach((el) => el.classList.add('in'));
  document.addEventListener('shopify:section:load', (e) => $$('.reveal', e.target).forEach((el) => el.classList.add('in')));

  const drawer = $('[data-drawer]');
  const setCount = (n) => $$('[data-cart-count]').forEach((c) => { c.textContent = n; c.hidden = !n; });
  const openDrawer = (o) => {
    if (!drawer) return;
    drawer.classList.toggle('open', o);
    drawer.setAttribute('aria-hidden', String(!o));
    body.style.overflow = o ? 'hidden' : '';
    if (o) { const c = $('.close[data-drawer-close]', drawer); if (c) setTimeout(() => c.focus({ preventScroll: true }), 50); }
  };
  const paint = (html) => {
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-drawer-content]', doc);
    const cur = $('[data-drawer-content]', drawer);
    if (fresh && cur) {
      cur.replaceWith(fresh);
      setCount(Number(fresh.dataset.count || 0));
    }
  };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open-cart]');
    if (t && drawer && !document.documentElement.classList.contains('on-cart')) { e.preventDefault(); openDrawer(true); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); openDrawer(false); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('open')) openDrawer(false);
    if (body.classList.contains('menu-open')) openMenu(false);
  });

  const change = async (line, quantity, scope) => {
    scope.classList.add('is-busy');
    try {
      const r = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: 'ma-cart-drawer', sections_url: window.location.pathname })
      });
      const d = await r.json();
      if (document.documentElement.classList.contains('on-cart')) { window.location.reload(); return; }
      paint(d.sections && d.sections['ma-cart-drawer']);
    } finally { scope.classList.remove('is-busy'); }
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (b) {
      const box = b.closest('.qty');
      const input = $('input', box);
      const min = Number(input.min || 0);
      const next = Math.max(min, Number(input.value || 0) + Number(b.dataset.qtyStep));
      input.value = next;
      if (input.dataset.line) change(Number(input.dataset.line), next, b.closest('.ligne') || box);
      return;
    }
    const rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); change(Number(rm.dataset.removeLine), 0, rm.closest('.ligne')); }
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('.qty input[data-line]');
    if (i) change(Number(i.dataset.line), Math.max(0, Number(i.value || 0)), i.closest('.ligne'));
  });

  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form.product-form');
    if (!f || !window.fetch || !drawer) return;
    e.preventDefault();
    const btns = $$('[data-atc]');
    const btn = $('[type=submit]', f);
    const label = btn.textContent;
    btns.forEach((b) => { b.disabled = true; });
    const fd = new FormData(f);
    fd.append('sections', 'ma-cart-drawer');
    fd.append('sections_url', window.location.pathname);
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || 'Indisponible');
      paint(d.sections && d.sections['ma-cart-drawer']);
      openDrawer(true);
      btns.forEach((b) => { b.disabled = false; });
    } catch (err) {
      btn.textContent = err.message && err.message.length < 60 ? err.message : 'Indisponible';
      setTimeout(() => { btn.textContent = label; btns.forEach((b) => { b.disabled = false; }); }, 2800);
    }
  });

  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-cx-variant]');
    if (!s) return;
    const o = s.options[s.selectedIndex];
    const p = $('[data-cx-price]', s.closest('[data-cx-form]'));
    if (p && o && o.dataset.price) p.textContent = o.dataset.price;
  });
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-cx-form]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    const b = $('.cx-add', f);
    const label = b.textContent;
    b.disabled = true;
    try {
      const r = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(f.elements.namedItem('id').value), quantity: 1 }], sections: 'ma-cart-drawer', sections_url: window.location.pathname })
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || 'Indisponible');
      if (document.documentElement.classList.contains('on-cart')) { window.location.reload(); return; }
      const inDrawer = drawer && drawer.contains(f);
      paint(d.sections && d.sections['ma-cart-drawer']);
      if (inDrawer) return;
      b.textContent = 'Ajouté';
      b.classList.add('done');
      setTimeout(() => { b.textContent = label; b.classList.remove('done'); b.disabled = false; }, 2200);
    } catch (err) {
      b.textContent = 'Indisponible';
      setTimeout(() => { b.textContent = label; b.disabled = false; }, 2600);
    }
  });

  const pf = $('form.product-form');
  const vjson = $('[data-variants]');
  if (pf && vjson) {
    const variants = JSON.parse(vjson.textContent);
    const idField = $('[name=id]', pf);
    const priceEls = $$('[data-price]');
    const btns = $$('[data-atc]');
    const groups = $$('[data-opt]', pf);
    const current = () => groups.map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
    const find = (vals) => variants.find((v) => v.options.every((o, i) => o === vals[i]));
    const update = () => {
      if (!groups.length) return;
      const vals = current();
      const v = find(vals);
      groups.forEach((g, gi) => {
        const lbl = $('[data-opt-value]', g);
        if (lbl) lbl.textContent = vals[gi] || '';
        $$('input', g).forEach((inp) => {
          const test = vals.slice(); test[gi] = inp.value;
          const m = find(test);
          inp.closest('.pill').classList.toggle('off', !m || !m.available);
        });
      });
      if (!v) { btns.forEach((b) => { b.disabled = true; b.textContent = 'Indisponible'; }); return; }
      idField.value = v.id;
      priceEls.forEach((p) => { p.textContent = euro(v.price); });
      btns.forEach((b) => { b.disabled = !v.available; b.textContent = v.available ? 'Ajouter au panier' : 'Épuisé'; });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
      if (v.featured_media) {
        const m = $(`[data-media-id="${v.featured_media.id}"]`);
        const gal = $('.product-media');
        if (m && gal && window.matchMedia('(max-width: 900px)').matches) gal.scrollTo({ left: m.offsetLeft, behavior: 'smooth' });
      }
    };
    groups.forEach((g) => g.addEventListener('change', update));
    update();
  }

  const gal = $('.product-media');
  const counter = $('[data-pm-count]');
  if (gal && counter) {
    const n = $$('.pm-item', gal).length;
    const f = () => { const i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth)) + 1; counter.textContent = `${Math.min(i, n)} / ${n}`; };
    gal.addEventListener('scroll', f, { passive: true });
    f();
    if (n < 2) counter.hidden = true;
  }

  const barre = $('[data-barre]');
  const main = $('[data-atc-main]');
  if (barre && main && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => barre.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(main);
    $('[data-barre-btn]', barre).addEventListener('click', () => {
      const f = main.closest('form');
      if (f.requestSubmit) f.requestSubmit(main); else f.submit();
    });
  }
})();
